var $name="sticky/recalculateStickyPositions",$path="app/modules/sticky/recalculateStickyPositions.js",$this={$name,$path,};import calculateTotalStickyHeight from './calculateTotalStickyHeight';
import setTopIndentToStickyElements from './setTopIndentToStickyElements';

function recalculateStickyPositions() {
  setTopIndentToStickyElements(window.stickyElements);
  calculateTotalStickyHeight();
}

export default recalculateStickyPositions;
